var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 4C32 1.79231 30.2077 0 28 0H4C1.79231 0 0 1.79231 0 4V28C0 30.2077 1.79231 32 4 32H28C30.2077 32 32 30.2077 32 28V4Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1725 11.1641H3.8125V27.2867H9.1725V11.1641Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.532 3.39062C4.69819 3.39062 3.5 4.59625 3.5 6.17644C3.5 7.72344 4.66175 8.96231 6.46106 8.96231H6.49569C8.36462 8.96231 9.52794 7.72344 9.52794 6.17644C9.49325 4.59625 8.36475 3.39062 6.532 3.39062V3.39062Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.329 10.7891C19.4859 10.7891 18.2124 12.3526 17.4992 13.4509V11.1682H12.1406C12.2117 12.6805 12.1406 27.2907 12.1406 27.2907H17.4992V18.2867C17.4992 17.8048 17.5338 17.323 17.6759 16.9786C18.0626 16.0161 18.9449 15.0191 20.4254 15.0191C22.3637 15.0191 23.1402 16.4981 23.1402 18.6645V27.2907H28.499V18.0451C28.499 13.0928 25.8549 10.7891 22.329 10.7891V10.7891Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.038099952a104099d4123258f153bf5c.svg";
export { ForwardRef as ReactComponent };